import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingDimensionReportLine  {
    _originalTypeClassName = "zERP.BO.AccountingDimensionReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingDimensionReportLine.translate = translateService;
}
this.Amount = null;
this.DimensionLabel = null;
this.Account = null;
this.AccountingDimensionReportLineKey = null;
this._key = this.AccountingDimensionReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Amount:any;
DimensionLabel:any;
Account:any;
private _AccountingDimensionReportLineKey:any;
get AccountingDimensionReportLineKey(): any {
    return this._AccountingDimensionReportLineKey;
  }
set AccountingDimensionReportLineKey(value: any) {
    this._AccountingDimensionReportLineKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountingDimensionReportLineKey == null || $this.AccountingDimensionReportLineKey == 0;
            }


}